export const matchUnitNumber = (unitNumber, camionNumber) =>
  camionNumber &&
  (unitNumber === camionNumber ||
    unitNumber?.includes(camionNumber) ||
    camionNumber?.includes(unitNumber) ||
    unitNumber?.toLowerCase() === camionNumber?.toLowerCase());

export const findEtaForUnit = (unit, suggestions) => {
  if (!unit?.suggested || !suggestions?.length) return null;

  for (const suggestion of suggestions) {
    if (!suggestion.etaMax) continue;
    for (const [key, camion] of Object.entries(suggestion.camion)) {
      if (matchUnitNumber(unit.number, camion)) {
        return suggestion.etaMax[key] || null;
      }
    }
  }
  return null;
};

export const combineSuggestions = (suggestions) => {
  const combined = { camion: {}, fecha: {}, hora: {}, etaMax: {} };
  let index = 0;

  suggestions.forEach((suggestion) => {
    Object.entries(suggestion.camion).forEach(([key, value]) => {
      combined.camion[index] = value;
      combined.fecha[index] = suggestion.fecha[key];
      combined.hora[index] = suggestion.hora[key];
      combined.etaMax[index] = suggestion.etaMax?.[key] || null;
      index++;
    });
  });

  return combined;
};
